/**
 * h5支付
 */
import axios from '../utils/http';

const orderBuild = params => {
    return axios.request({
        data: {
        ...params
        },
        headers:{'userid':params.userId},
        method: 'post',
        url: '/v1/sell/order/h5/build'
   })
}

const getAccessToken = params => { // 获取openId
    return axios.request({
        data: {
        ...params
        },
        method: 'post',
        url: '/v1/sell/order/getAccessToken'
   })
}
 
export default {
    orderBuild,
    getAccessToken
}